module.exports = __webpack_public_path__ + "img/img2.b26a9dff.jpg";